(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bsk-article"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const slugify = (value) => value
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ı/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/ş/g, 's')
      .replace(/ç/g, 'c')
      .replace(/ö/g, 'o')
      .replace(/ü/g, 'u')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    const initializeArticle = (root) => {
      if (root.dataset.bskArticleReady === 'true') return;
      root.dataset.bskArticleReady = 'true';

      const content = root.querySelector('[data-bsk-article-content]');
      if (!content) return;

      const headings = Array.from(content.querySelectorAll('h2, h3')).filter((heading) => heading.textContent.trim());
      const lists = Array.from(root.querySelectorAll('[data-bsk-toc-list]'));
      const usedIds = new Set();

      headings.forEach((heading, index) => {
        let id = heading.id || slugify(heading.textContent) || `bolum-${index + 1}`;
        const baseId = id;
        let suffix = 2;
        while (usedIds.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
          id = `${baseId}-${suffix}`;
          suffix += 1;
        }
        usedIds.add(id);
        heading.id = id;

        lists.forEach((list) => {
          const item = document.createElement('li');
          item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
          const link = document.createElement('a');
          link.href = `#${id}`;
          link.textContent = heading.textContent.trim();
          link.addEventListener('click', (event) => {
            event.preventDefault();
            heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.replaceState(null, '', `#${id}`);
            const details = link.closest('details');
            if (details && window.matchMedia('(max-width: 900px)').matches) details.open = false;
          });
          item.appendChild(link);
          list.appendChild(item);
        });
      });

      root.querySelectorAll('[data-bsk-toc-count]').forEach((node) => {
        node.textContent = `${headings.length} bölüm`;
      });

      if (headings.length === 0) {
        root.querySelectorAll('.bsk-article-toc').forEach((toc) => toc.hidden = true);
      } else if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
          if (!visible) return;
          lists.forEach((list) => {
            list.querySelectorAll('li').forEach((item) => item.classList.remove('is-active'));
            const active = list.querySelector(`a[href="#${CSS.escape(visible.target.id)}"]`);
            if (active) active.parentElement.classList.add('is-active');
          });
        }, { rootMargin: '-18% 0px -70% 0px', threshold: 0 });
        headings.forEach((heading) => observer.observe(heading));
      }

      root.querySelectorAll('[data-bsk-copy-url]').forEach((button) => {
        button.addEventListener('click', async () => {
          const original = button.textContent;
          try {
            await navigator.clipboard.writeText(button.dataset.bskCopyUrl);
            button.textContent = 'Kopyalandı';
          } catch (error) {
            window.prompt('Bağlantıyı kopyalayın:', button.dataset.bskCopyUrl);
          }
          window.setTimeout(() => button.textContent = original, 1800);
        });
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-bsk-article]').forEach(initializeArticle);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsk-collection"]) return;
  try {
    
(() => {
  const prepareCopy = (section) => {
    const body = section.querySelector('[data-bsk-collection-copy-body]');
    const toggle = section.querySelector('[data-bsk-collection-copy-toggle]');
    if (!body || !toggle || section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';

    const setCollapsedHeight = () => {
      const firstParagraph = body.querySelector('p') || body.firstElementChild;
      if (!firstParagraph) return;
      const height = firstParagraph.getBoundingClientRect().bottom - body.getBoundingClientRect().top + 2;
      body.style.setProperty('--bsk-copy-collapsed-height', `${Math.ceil(height)}px`);
      if (body.scrollHeight <= height + 8) {
        body.classList.add('is-expanded');
        toggle.hidden = true;
      }
    };

    setCollapsedHeight();
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      body.classList.toggle('is-expanded', !expanded);
    });
    window.addEventListener('resize', setCollapsedHeight, { passive: true });
  };

  document.querySelectorAll('[data-bsk-collection-copy]').forEach(prepareCopy);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-bsk-collection-copy]').forEach(prepareCopy);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
